export const starSystems = [
  {
    id: 1200,
    name: "Hyrule Kingdom",
    type: "planet",
    distance: 0,
    coordinates: { x: 45, y: 50, z: 0 },
    threat: "low",
    resources: ["water", "food", "minerals"],
    services: ["refuel", "repair", "trade", "medical"],
    tradeType: "balanced",
    primaryColor: "#00AA00",
    secondaryColor: "#FFD700",
    hasRings: false,
    description: "The legendary kingdom of Hyrule, home to Princess Zelda and the Triforce. Rolling green fields stretch as far as the eye can see.",
    scanDescription: "Detecting ancient magical energies and a strong civilization presence. Multiple settlements and castle structures visible."
  },
  {
    id: 1201,
    name: "Death Mountain",
    type: "planet",
    distance: 18,
    coordinates: { x: 60, y: 55, z: 3 },
    threat: "high",
    resources: ["minerals", "rare_metals", "energy"],
    services: ["refuel"],
    tradeType: "industrial",
    primaryColor: "#FF4400",
    secondaryColor: "#FFD700",
    hasRings: false,
    description: "A massive volcanic mountain inhabited by the Goron tribe. Lava flows and intense heat make this a dangerous but resource-rich world.",
    scanDescription: "High volcanic activity detected. Extreme temperatures and mineral deposits throughout the surface."
  },
  {
    id: 1202,
    name: "Zora's Domain",
    type: "planet",
    distance: 22,
    coordinates: { x: 30, y: 60, z: -5 },
    threat: "low",
    resources: ["water", "food", "medicine"],
    services: ["refuel", "medical", "repair"],
    tradeType: "medical",
    primaryColor: "#0066FF",
    secondaryColor: "#00AA00",
    hasRings: true,
    description: "An aquatic paradise ruled by the Zora people. Crystal-clear waters and healing springs make this a peaceful sanctuary.",
    scanDescription: "Abundant water sources and aquatic life forms detected. Advanced healing facilities present."
  },
  {
    id: 1203,
    name: "Gerudo Desert",
    type: "planet",
    distance: 16,
    coordinates: { x: 55, y: 35, z: 8 },
    threat: "medium",
    resources: ["rare_metals", "gems", "energy"],
    services: ["refuel", "trade"],
    tradeType: "luxury",
    primaryColor: "#FFD700",
    secondaryColor: "#FF8800",
    hasRings: false,
    description: "A vast desert realm ruled by the warrior women of the Gerudo tribe. Hidden treasures lie beneath the shifting sands.",
    scanDescription: "Extreme desert conditions with valuable mineral deposits. Fortified settlements detected."
  },
  {
    id: 1204,
    name: "Skyloft",
    type: "station",
    distance: 25,
    coordinates: { x: 40, y: 70, z: 2 },
    threat: "low",
    resources: ["technology", "food"],
    services: ["refuel", "repair", "trade"],
    tradeType: "technology",
    primaryColor: "#87CEEB",
    secondaryColor: "#FFD700",
    hasRings: false,
    description: "A floating island high above the clouds, home to the Knight Academy. Ancient technology keeps this station aloft.",
    scanDescription: "Floating structure detected with advanced anti-gravity systems. Peaceful civilization present."
  },
  {
    id: 1205,
    name: "Kakariko Village",
    type: "planet",
    distance: 20,
    coordinates: { x: 65, y: 45, z: -3 },
    threat: "low",
    resources: ["food", "medicine", "artifacts"],
    services: ["refuel", "medical", "information"],
    tradeType: "information",
    primaryColor: "#8B4513",
    secondaryColor: "#00AA00",
    hasRings: false,
    description: "A peaceful mountain village known for its ancient wisdom and Sheikah technology. The well and graveyard hold many secrets.",
    scanDescription: "Ancient settlement with mysterious technological artifacts. Strong spiritual energy readings."
  },
  {
    id: 1206,
    name: "Temple of Time",
    type: "station",
    distance: 28,
    coordinates: { x: 25, y: 45, z: 10 },
    threat: "medium",
    resources: ["artifacts", "energy", "knowledge"],
    services: ["refuel", "information"],
    tradeType: "artifacts",
    primaryColor: "#FFD700",
    secondaryColor: "#0066FF",
    hasRings: false,
    description: "An ancient temple that serves as a gateway through time itself. The Master Sword rests within its sacred halls.",
    scanDescription: "Massive temporal energy fluctuations detected. Ancient architecture with powerful magical resonance."
  },
  {
    id: 1207,
    name: "Lorule",
    type: "planet",
    distance: 24,
    coordinates: { x: 50, y: 65, z: -8 },
    threat: "high",
    resources: ["dark_energy", "rare_metals", "artifacts"],
    services: ["refuel", "trade"],
    tradeType: "dark_market",
    primaryColor: "#4B0082",
    secondaryColor: "#FFD700",
    hasRings: true,
    description: "A dark mirror world of Hyrule where the Triforce was destroyed. Reality itself seems unstable in this twisted realm.",
    scanDescription: "Dimensional instabilities detected. Dark energy signatures and corrupted magical fields present."
  },
  {
    id: 1208,
    name: "Termina",
    type: "planet",
    distance: 26,
    coordinates: { x: 35, y: 35, z: 5 },
    threat: "high",
    resources: ["masks", "magic", "artifacts"],
    services: ["refuel", "trade"],
    tradeType: "mystical",
    primaryColor: "#8A2BE2",
    secondaryColor: "#FFD700",
    hasRings: false,
    description: "A parallel world trapped in a three-day cycle, threatened by a falling moon. Strange masks hold incredible power here.",
    scanDescription: "Temporal anomalies detected. Massive celestial body on collision course. Powerful magical artifacts present."
  },
  {
    id: 1209,
    name: "Dark World",
    type: "planet",
    distance: 30,
    coordinates: { x: 60, y: 30, z: -10 },
    threat: "extreme",
    resources: ["dark_energy", "cursed_artifacts", "shadow_crystals"],
    services: ["refuel"],
    tradeType: "forbidden",
    primaryColor: "#2F0F2F",
    secondaryColor: "#8B0000",
    hasRings: false,
    description: "A corrupted version of Hyrule where evil reigns supreme. Those who enter risk having their true nature revealed.",
    scanDescription: "Extreme dark energy readings. Hostile magical interference detected. Approach with extreme caution."
  },
  {
    id: 1299,
    name: "Black Hole",
    type: "blackhole",
    distance: 26000,
    coordinates: { x: 42, y: 48, z: -12 },
    threat: "extreme",
    resources: [],
    services: ["refuel"],
    tradeType: "none",
    primaryColor: "#000000",
    secondaryColor: "#4B0082",
    hasRings: true,
    description: "A massive gravitational anomaly that devours light itself. Some say it leads to other dimensions.",
    scanDescription: "Extreme gravitational distortion detected. Event horizon approaching critical distance. Immediate retreat recommended."
  }
];

export const starPositions = starSystems.reduce((acc, system) => {
  if (system.coordinates) {
    acc[system.id] = system.coordinates;
  }
  return acc;
}, {});